import { render } from "./RoomCard.vue?vue&type=template&id=407f2a1e&scoped=true&lang=pug"
import script from "./RoomCard.vue?vue&type=script&lang=js"
export * from "./RoomCard.vue?vue&type=script&lang=js"

import "./RoomCard.vue?vue&type=style&index=0&id=407f2a1e&scoped=true&lang=css"

import exportComponent from "/Users/bestian/Documents/GitHub/cschool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-407f2a1e"]])

export default __exports__